export default __webpack_public_path__ + "static/media/Group 11812.a7cb9c5a.svg";